import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IconUIComponent } from '../../icon/icon.component';

@Component({
  selector: 'fr8bot-ui-business-header-markup',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './business-header-markup.component.html',
  styleUrl: './business-header-markup.component.scss',
  imports: [IconUIComponent],
})
export class BusinessHeaderMarkupUIComponent {
  showGoBack = input(true);
  goBack = output();
}
